import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sqg-folders" }
const _hoisted_2 = { class: "sqg-folders__line" }
const _hoisted_3 = { class: "sqg-folders__line" }
const _hoisted_4 = { class: "sqg-folders__line" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_7 = { class: "sqg-folders__line" }
const _hoisted_8 = { class: "sqg-folders__check" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" éléments sélectionnés ")
const _hoisted_10 = {
  key: 0,
  class: "sqg-folders__actions"
}
const _hoisted_11 = { style: {"position":"relative","width":"100%"} }
const _hoisted_12 = {
  key: 0,
  class: "sqg-folders__results"
}
const _hoisted_13 = {
  key: 0,
  class: "sqg-folders__noResults"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Aucun dossiers ... ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "sqg-folders__results"
}

import {computed, ComputedRef, defineAsyncComponent, defineComponent, onMounted, ref} from "vue";
import Folder from "@/types/Folder";
import {useFoldersStore} from "@/stores/folders";
import {useUserStore} from "@/stores/user";
import {storeToRefs} from "pinia";
import router from "@/router";
import {AxiosResponse} from "axios";
import {useRoute} from "vue-router";
import {arrayHasBasedOnId, arrayToggleBaseOnId, getFolderIcone, isActionAvailable} from '@/functions/utils';

import Header from '@/components/Header.vue';
import CardButton from '@/components/CardButton.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import CardFilter from '@/components/CardFilter.vue';
import Card from '@/components/Card.vue';
import Input from '@/components/Input.vue';
import CreateFolder from '@/modales/CreateFolder.vue';
import UploadFile from '@/modales/CreateFolder.vue';
import TableItemSkeleton from '@/components/TableItemSkeleton.vue';
import TableItem from '@/components/TableItem.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

//STORE folders
const foldersStore = useFoldersStore();
const {folders, folderLoader} = storeToRefs(foldersStore);
//STORE user
const usersStore = useUserStore();
const {user} = storeToRefs(usersStore);
//DATA
const loader = ref(true);
const loaderErrorMsg = ref('');
const isCreateFolderOpen = ref(false);
const isUploadFileOpen = ref(false);
const foldersCheck = ref<Array<any>>([]);

//DISPLAY FOLDER
const searchTerm = ref('');
const customerTerm = ref('');
const stateFilters = ref<Array<String>>([]);
const filterBy = (type: Array<String>) => {
  if (isActive(type)) {
    stateFilters.value.splice(0, stateFilters.value.length);
  } else {
    stateFilters.value.splice(0, stateFilters.value.length);
    type.forEach(elem => stateFilters.value.push(elem));
  }
};
const isActive = (type: Array<String>) => {
  return type.every(elem => stateFilters.value.includes(elem));
};
const foldersToDisplay: ComputedRef<Array<Object>> = computed(() => {
  let result = folders.value.filter((folder) => folder.state !== 'termine');
  if (stateFilters.value.length > 0) result = result.filter((folder: Folder) => stateFilters.value.includes(folder.state));
  if (searchTerm.value !== '') result = result.filter((folder: Folder) => folder.name.includes(searchTerm.value));
  if (customerTerm.value !== '') result = result.filter((folder: Folder) => folder.customerCompany.includes(customerTerm.value));
  return result.map((item: any) => {
    let actions: Array<Object>;
    switch (item.state) {
      case 'attente_validation':
        actions = [{action: 'empty'}];
        user.value.role === 'gestionnaireDeDossier' ?
            actions.push({action: 'empty'}) :
            actions.push({ icon: 'fa-solid fa-circle-check', text: 'Valider', action: 'validate' });
        break;
      case 'initialisation':
        actions = [
          { icon: 'fas fa-arrow-right',text: 'Sélectionner',action: 'select' },
          { icon: 'fas fa-file-upload', text: 'Joindre', action: 'upload' }
        ];
        break;
      case 'done':
        actions = [
          { icon: 'fas fa-arrow-right',text: 'Sélectionner',action: 'select'},
          { icon: 'fas fa-file-upload', text: 'Joindre', action: 'upload'}
        ];
        break;
      default:
        actions = [
          { icon: 'fas fa-arrow-right', text: 'Sélectionner', action: 'select' },
          { icon: 'fas fa-file-upload', text: 'Joindre', action: 'upload' }
        ];
        break;
    }
    if (user.value.role === 'admin' || user.value.role === 'superAdmin') {
      if (item.followers.includes(user.value.id)) actions.push({ icon: 'fa-solid fa-eye-slash', text: 'Libérer', action: 'unfollow' });
      else actions.push({ icon: 'fa-solid fa-eye', text: 'Suivre', action: 'follow' });
    }
    const fields = [
      {title: 'Dossier', value: item.name},
      {title: 'Entreprise', value: item.customerCompany},
      {title: 'Créé le', value: new Date(item.creationDate).toLocaleString()},
      {type: 'icone', popper: item.nbFile + ' fichier(s)', redirect: 'files', title: 'fas fa-file', value: item.nbFile},
      {type: 'icone', popper: item.nbForm + ' formulaire(s)', redirect: 'forms', title: 'fas fa-align-center', value: item.nbForm},
    ];
    return {
      id: item.id,
      name: item.name,
      nbForm: item.nbForm,
      nbFile: item.nbFile,
      logo: getFolderIcone(item.state),
      fields: fields,
      actions: actions,
      state: item.state
    };
  });
});

const createFolderSuccess = () => {
  loader.value = true;
  isCreateFolderOpen.value = false;
  foldersStore.getFolders().then(() => {
    loader.value = false;
  });
};

const uploadFileSuccess = () => {
  foldersStore.goLoader();
  isUploadFileOpen.value = false;
  foldersStore.getFolders().then(() => {
    foldersStore.stopLoader()
  });
};

const folderIdArray = ref<Array<string>>([]);
const openFileUploader = (folderIds: [string]) => {
  console.log(folderIds);
  folderIdArray.value = [];
  folderIds.forEach((folderId) => folderIdArray.value.push(folderId));
  isUploadFileOpen.value = true;
};

const setFolder = (folder: any, path: string) => {
  path ? router.push(`/folder/${folder.id}/${path}`) : router.push(`/folder/${folder.id}`);
  foldersStore.goLoader();
  foldersStore.getFolderById(folder.id).then((response: AxiosResponse) => {
    foldersStore.setCurrentFolder(response.data);
    usersStore.addFolderToFavorite(folder.id, folder.name, folder.nbForm, folder.nbFile, folder.state);
    usersStore.setCurrentFolderId(folder.id);
    foldersStore.stopLoader();
  });
};

const toggleFoldersCheck = () => {
  if (foldersCheck.value.length === 0) {
    foldersToDisplay.value.forEach((folder: any) => arrayToggleBaseOnId(foldersCheck.value, folder));
  } else {
    foldersCheck.value = [];
  }
};

const validateFolder = (folderId: string) => {
  foldersStore.goLoader();
  foldersStore.validateFolder(folderId)
      .then(() => foldersStore.getFolders()
          .then(() => foldersStore.stopLoader()));
};

const validateAll = async () => {
  foldersStore.goLoader();
  for (const folderId of foldersCheck.value) {
    const tmpFolder = folders.value.find((folder) => folder.id === folderId.id);
    if (tmpFolder) await foldersStore.validateFolder(tmpFolder.id);
  }
  foldersStore.getFolders().then(() => foldersStore.stopLoader());
}

 const follow = (folderId: string) => {
  foldersStore.follow(folderId).then(() => {
    foldersStore.goLoader();
    if (route.params.filter) {
      let filters = route.params.filter as Array<string>;
      filters.forEach((item: any) => stateFilters.value.push(item));
    }
    foldersStore.getFolders().then(() => {
      foldersStore.stopLoader();
    })
  });
}

const unfollow = (folderId: string) => {
  foldersStore.unfollow(folderId).then(() => {
    foldersStore.goLoader();
    if (route.params.filter) {
      let filters = route.params.filter as Array<string>;
      filters.forEach((item: any) => stateFilters.value.push(item));
    }
    foldersStore.getFolders().then(() => {
      foldersStore.stopLoader();
    })
  });
}

onMounted(() => {
  foldersStore.goLoader();
  if (route.params.filter) {
    let filters = route.params.filter as Array<string>;
    filters.forEach((item: any) => stateFilters.value.push(item));
  }
  foldersStore.getFolders().then(() => {
    foldersStore.stopLoader();
  })
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header, {
        icone: "fas fa-layer-group",
        title: "Liste des dossiers en cours",
        displayCurrentFolder: false
      }),
      _createElementVNode("div", {
        class: _normalizeClass(['sqg-folders__board', {'-loading': _unref(folderLoader)}])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(CardButton, {
            width: "25",
            height: "96",
            class: "sqg-formsNavigation__submit clickable",
            icon: "fas fa-folder-plus",
            text: "Créer un dossier",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isCreateFolderOpen.value = true))
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_unref(folderLoader))
            ? (_openBlock(), _createBlock(Card, {
                key: 0,
                width: "100",
                height: "70px"
              }, {
                default: _withCtx(() => [
                  _createVNode(Loader, { size: "44" })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(CardFilter, {
                key: 1,
                width: "100",
                height: "80px",
                title: "En attente de validation",
                number: _unref(folders).filter((folder) => folder.state === 'attente_validation').length,
                icone: "far fa-folder",
                isActive: isActive(['attente_validation']),
                onFilter: _cache[1] || (_cache[1] = ($event: any) => (filterBy(['attente_validation'])))
              }, null, 8, ["number", "isActive"])),
          (_unref(folderLoader))
            ? (_openBlock(), _createBlock(Card, {
                key: 2,
                width: "100",
                height: "70px"
              }, {
                default: _withCtx(() => [
                  _createVNode(Loader, { size: "44" })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(CardFilter, {
                key: 3,
                width: "100",
                height: "80px",
                title: "Dossiers initiés",
                number: _unref(folders).filter((folder) => folder.state === 'initialisation').length,
                icone: "fa-regular fa-folder-open",
                isActive: isActive(['initialisation']),
                onFilter: _cache[2] || (_cache[2] = ($event: any) => (filterBy(['initialisation'])))
              }, null, 8, ["number", "isActive"])),
          (_unref(folderLoader))
            ? (_openBlock(), _createBlock(Card, {
                key: 4,
                width: "100",
                height: "70px"
              }, {
                default: _withCtx(() => [
                  _createVNode(Loader, { size: "44" })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(CardFilter, {
                key: 5,
                width: "100",
                height: "80px",
                title: "Dossiers en cours",
                number: _unref(folders).filter((folder) => folder.state === 'configuration' || folder.state === 'montage' || folder.state === 'validation').length,
                icone: "fas fa-folder-open",
                isActive: isActive(['configuration', 'validation', 'montage']),
                onFilter: _cache[3] || (_cache[3] = ($event: any) => (filterBy(['configuration', 'validation', 'montage'])))
              }, null, 8, ["number", "isActive"]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Card, {
            width: "100",
            height: "40",
            class: "sqg-folders__search"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(Input, {
                type: "text",
                placeholder: "Rechercher un dossier ...",
                modelValue: searchTerm.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchTerm).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_unref(user).role === 'admin' || _unref(user).role === 'superAdmin')
            ? (_openBlock(), _createBlock(Card, {
                key: 0,
                width: "100",
                height: "40",
                class: "sqg-folders__search"
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createVNode(Input, {
                    type: "text",
                    placeholder: "Rechercher une entreprise ...",
                    modelValue: customerTerm.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((customerTerm).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Checkbox, {
              id: "selectAll",
              checked: foldersCheck.value.length === _unref(foldersToDisplay).length,
              onOnChange: _cache[6] || (_cache[6] = ($event: any) => (toggleFoldersCheck()))
            }, null, 8, ["checked"]),
            _createElementVNode("strong", null, "( " + _toDisplayString(foldersCheck.value.length) + " )", 1),
            _hoisted_9
          ]),
          (foldersCheck.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_unref(user).role === 'responsable' && _unref(isActionAvailable)(foldersCheck.value, 'validate'))
                  ? (_openBlock(), _createBlock(CardButton, {
                      key: 0,
                      small: "",
                      icon: "fa-regular fa-circle-check",
                      text: "Tout valider",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (validateAll()))
                    }))
                  : _createCommentVNode("", true),
                (_unref(user).role !== 'gestionnaireDeDossier' && _unref(isActionAvailable)(foldersCheck.value, 'upload'))
                  ? (_openBlock(), _createBlock(CardButton, {
                      key: 1,
                      small: "",
                      icon: "fas fa-file-upload",
                      text: "Joindre des fichiers",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (openFileUploader(foldersCheck.value.map((folder) => folder.id))))
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_unref(folderLoader))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (folder, index) => {
                  return _createVNode(TableItemSkeleton, {
                    key: index,
                    ratio: 10,
                    fields: [{}, {}, {}, {}],
                    actions: [{}]
                  })
                }), 64))
              ]))
            : _createCommentVNode("", true),
          (!_unref(folderLoader))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(foldersToDisplay).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(foldersToDisplay), (folder, index) => {
                        return (_openBlock(), _createBlock(TableItem, {
                          key: folder.id,
                          item: folder,
                          isCheck: _unref(arrayHasBasedOnId)(foldersCheck.value, folder),
                          onSelect: ($event: any) => (setFolder(folder, undefined)),
                          onUpload: ($event: any) => (openFileUploader([folder.id])),
                          onValidate: ($event: any) => (validateFolder(folder.id)),
                          onRedirect: ($event: any) => (setFolder(folder, $event)),
                          onCheck: _cache[9] || (_cache[9] = ($event: any) => (_unref(arrayToggleBaseOnId)(foldersCheck.value, $event))),
                          onFollow: ($event: any) => (follow(folder.id)),
                          onUnfollow: ($event: any) => (unfollow(folder.id))
                        }, null, 8, ["item", "isCheck", "onSelect", "onUpload", "onValidate", "onRedirect", "onFollow", "onUnfollow"]))
                      }), 128))
                    ]))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _createVNode(CreateFolder, {
      isOpen: isCreateFolderOpen.value,
      onClose: _cache[10] || (_cache[10] = ($event: any) => (isCreateFolderOpen.value = false)),
      onCreateFolder: createFolderSuccess
    }, null, 8, ["isOpen"]),
    _createVNode(UploadFile, {
      folderIds: folderIdArray.value,
      isOpen: isUploadFileOpen.value,
      onClose: _cache[11] || (_cache[11] = ($event: any) => (isUploadFileOpen.value = false)),
      onUploadFile: uploadFileSuccess
    }, null, 8, ["folderIds", "isOpen"])
  ], 64))
}
}

})